import {useParams} from "react-router-dom";
import CountryContext from "../../CountryContext";
import {PageHeading} from "../../ui-components/Container";
import {NotificationsContext} from "../../ui-components/Notifications";
import {useIntl} from "react-intl";
import {useContext} from "react";
import React, {useState, useEffect} from "react";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import WorksiteDocumentsComponent from "./WorksiteDocumentsComponent"

const WorksiteDocuments = () => {
	// params
	const {worksite_id} = useParams();
	const [worksite, setWorksite] = useState()
	const [search, setSearch] = useState("")

  // context
  const intl = useIntl();
  const { country } = useContext(CountryContext);
  const { push } = useContext(NotificationsContext);

	const countryApiRequest = useCountryAxiosInstance(country.code);

	useEffect(() => {
		countryApiRequest.get(`/worksites/${worksite_id}`)
			.then(setWorksite)
			.catch((error) => {
				push({type: 'error', title: intl.formatMessage({id: 'server_error'})});
				throw error;
			})
	}, [worksite_id, countryApiRequest]);  // eslint-disable-line react-hooks/exhaustive-deps

	return (<>
    <PageHeading
      title={intl.formatMessage({ id: "worksite_documents" })}
      historyBackPath={`/${country.code}/worksites/${worksite_id}`}
    />
		{worksite &&
			<WorksiteDocumentsComponent
				worksite={worksite}
				/>
		}
		</>
	);
}

export default WorksiteDocuments;